import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { createChatBotMessage } from 'react-chatbot-kit';
import axios from 'axios';
import { BrainLoader } from '../../../Components/Generics.styled';

const EmailGPT = ({ state, setState, actions, userInput }) => {
    const [gptPostData, setGptPostData] = useState({
        isLoading: false,
        error: false,
        success: false,
    });

    const generateEmail = async () => {
        setGptPostData({ ...gptPostData, isLoading: true });

        try {
            const chatGPTResponse = await axios({
                method: 'post',
                url: process.env.REACT_APP_API_DAVIE_AI,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${process.env.REACT_APP_API_DAVIE_AI_SECRET}`,
                },

                data: {
                    model: 'gpt-4.1',
                    // response_format:{ "type": "json_object" },
                    messages: [
                        {
                            role: 'system',
                            content: 'Pretend to be a professional email writer.',
                        },
                        {
                            role: 'user',
                            content: `I am going to give you a user input. The user input will give you context on what the email should be about. I want you to generate me a professionally written email about this content. You need to stay as close to the content as possible, if a user says only 3 setences than do just that for example. Return only the generated email as text. Nothing else. Here is the user input: ${userInput} `,
                        },
                    ],
                    temperature: 0.8,
                },
            });

            const response = chatGPTResponse?.data?.choices[0]?.message.content;
            if (response) {
                setGptPostData({ ...gptPostData, isLoading: false });
                const message = createChatBotMessage(response);

                setState((prev) => ({
                    ...prev,
                    messages: [...prev.messages, message],
                    userInput: userInput,
                }));

                setTimeout(() => {
                    const subsequentMessage = createChatBotMessage(
                        'Do you need help with anything else?',
                        {
                            // Additional configurations for the message
                        }
                    );

                    setState((prev) => ({
                        ...prev,
                        messages: [...prev.messages, subsequentMessage],
                        userInput: userInput,
                    }));
                }, 1000); // 5000 milliseconds = 5 seconds
            }
        } catch (err) {
            setGptPostData({ ...gptPostData, isLoading: false, error: true });
            const message = createChatBotMessage('Something went wrong please try again');

            setState((prev) => ({
                ...prev,
                messages: [...prev.messages, message],
                userInput: userInput,
            }));
        }

        // setGptResp(response)
    };

    useEffect(() => {
        generateEmail();
    }, []);

    return <div>{gptPostData?.isLoading ? <BrainLoader width="100px" /> : null}</div>;
};

EmailGPT.propTypes = {
    actions: propTypes.shape({}),
    state: propTypes.shape({
        messages: propTypes.array,
        userInput: propTypes.oneOfType([propTypes.string, propTypes.shape({})]),
    }),
    setState: propTypes.func,
    userInput: propTypes.oneOfType([propTypes.string, propTypes.shape({})]),
};

export default EmailGPT;
